import { useDispatch, useSelector } from "react-redux";
import DropdownFilter from "components/DropdownFilter";
import { setVendorId, selectVendorId, selectClientAccountId, selectClientId, setClientAccountId, setClientId, selectStartDate, selectEndDate, setStartDate, setEndDate, selectRangeType, setRangeType } from "./dashboardFiltersSlice";
import { useGetVendorsQuery } from 'features/vendor/vendorSlice';
import { Grid, Paper } from "@material-ui/core";
import { useGetClientsQuery } from 'features/clients/clientSlice';
import { vendorDashStyle } from "./style";
import { DefaultRangesTypes, PredefinedRangesByKey } from "components/DateRange/DefaultRanges";

export const VendorDashboardFilters = ({ isLoadingDashboardData }) => {
    const classes = vendorDashStyle();
    const dispatch = useDispatch();
    const vendorId = useSelector(selectVendorId);
    const clientId = useSelector(selectClientId);
    const clientAccountId = useSelector(selectClientAccountId);
    const startDate = useSelector(selectStartDate);
    const endDate = useSelector(selectEndDate);
    const rangeType = useSelector(selectRangeType);
    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();
    const { data: clients = [], isLoadingClients } = useGetClientsQuery();
    const clientAccounts = clientId != null ? clients?.find(c => c.id == clientId)?.clientAccounts : clients?.flatMap(c => c.clientAccounts);


    const now = new Date();
    const timeFrameOptions = [
        PredefinedRangesByKey[DefaultRangesTypes.THIRTY_DAYS],
        PredefinedRangesByKey[DefaultRangesTypes.THREE_MONTHS],
        PredefinedRangesByKey[DefaultRangesTypes.SIX_MONTHS],
        PredefinedRangesByKey[DefaultRangesTypes.TWELVE_MONTHS]
    ]?.map(opt => ({
        name: opt.label,
        id: opt.key,
        ...opt
    }));


    const handleTimeFrameChange = (option) => {
        dispatch(setStartDate(option?.range().startDate.toDateString()));
        dispatch(setEndDate(option?.range().endDate.toDateString()));
        dispatch(setRangeType(option?.id));
    };

    const filters = [
        {
            id: "dashboard-vendor-filter",
            label: "Vendor",
            value: vendorId,
            onSelect: v => dispatch(setVendorId(v?.id ?? null)),
            values: vendors,
            elementType: "dropdown",
            showEmpty: true,
            withTypeAhead: true,
            withTypeAhead: true,
            showEmpty: true
        },
        {
            id: "dashboard-client-filter",
            label: "Client",
            value: clientId,
            onSelect: v => dispatch(setClientId(v?.id ?? null)),
            values: clients,
            visible: clients?.length > 0,
            withTypeAhead: true,
            showEmpty: true
        },
        {
            id: "dashboard-client-account-filter",
            label: "Sub client",
            value: clientAccountId,
            onSelect: v => dispatch(setClientAccountId(v?.id ?? null)),
            values: clientAccounts,
            visible: clientAccounts?.length > 0,
            withTypeAhead: true,
            showEmpty: true
        },
        {
            id: "dashboard-timeframe-filter",
            label: "Time Frame",
            value: rangeType,
            onSelect: handleTimeFrameChange,
            values: timeFrameOptions,
            withTypeAhead: true,
            showEmpty: false
        }
    ]



    return (
        <Paper className={classes.card} style={{ padding: '1em' }}>
            <Grid container direction="row" spacing={2}>
                {filters.map(filter => (
                    <Grid item xs={12} sm={6} md={3} key={filter.id} className="filter-title">
                        <div className={classes.statTitle} >{filter?.label}</div>
                        <DropdownFilter
                            disabled={isLoadingDashboardData}
                            id={filter.id}
                            label={filter.label}
                            value={filter.value}
                            onSelect={filter.onSelect}
                            values={filter.values}
                            elementType={'dropdown'}
                            showEmpty={filter?.showEmpty}
                            withTypeAhead={filter.withTypeAhead}
                        />
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
};
